import type { EndlessEntry } from '../sim/defs';

/* ═══════════════════════════════════════════════════════════════════════════
   LE ROSTER DU MODE SANS FIN.

   Le mode sans fin n'a pas de partition : il n'y a pas de `LevelDef`, pas de
   boss, pas d'horloge de fin. `endlessSystem` puise dans CE roster, impulsion
   après impulsion, et durcit la partie avec le temps écoulé.

   ── Comment le temps durcit la partie ──
   Le mode débloque un PALIER de plus toutes les `ENDLESS_STAGE_SECONDS`. Un
   ennemi n'est éligible au tirage qu'une fois son `tier` atteint. Les paliers
   bas ne contiennent que du menu fretin ; les lourds, les blindés et les armes
   exotiques n'arrivent que plus tard — le temps où le build du joueur a eu de
   quoi les encaisser. À cela s'ajoutent des PV qui grimpent et des impulsions de
   plus en plus rapprochées : trois leviers indépendants, réglés ici et dans
   `endlessSystem`.

   ⚠️ Cette liste est ÉCRITE, donc RELUE — comme la campagne. Un glob trierait
   par chemin et l'ordre des paliers y est significatif à la lecture. Elle ne
   référence que des ennemis AUTONOMES : jamais une partie de boss (elle
   s'attache à un porteur), jamais un œuf ou une larve (ils naissent d'une ponte),
   jamais un boss entier. `validate()` vérifie au chargement que chaque
   identifiant existe.

   ── Les natures, mêlées à dessein ──
   Chaque palier mélange l'organique et le mécanique, le rapide et le lourd, le
   balistique et l'exotique. Une partie sans fin ne doit pas se lire comme une
   liste ordonnée d'archétypes mais comme une pression qui se diversifie.
   ═══════════════════════════════════════════════════════════════════════════ */

export const ENDLESS_ROSTER: readonly EndlessEntry[] = [
  // ── Palier 0 : le fretin. Dès la première seconde.
  { enemy: 'mite', tier: 0, weight: 5 },
  { enemy: 'eclat', tier: 0, weight: 4 },
  { enemy: 'dard', tier: 0, weight: 3 },
  { enemy: 'spore', tier: 0, weight: 2 },

  // ── Palier 1 : les standards mobiles.
  { enemy: 'rodeur', tier: 1, weight: 3 },
  { enemy: 'harceleur', tier: 1, weight: 3 },
  { enemy: 'guepe', tier: 1, weight: 3 },
  { enemy: 'fauche', tier: 1, weight: 2 },
  { enemy: 'chasseur', tier: 1, weight: 2 },

  // ── Palier 2 : les premières vraies menaces.
  { enemy: 'faucheur', tier: 2, weight: 2 },
  { enemy: 'mitrailleur', tier: 2, weight: 2 },
  { enemy: 'tourbillon', tier: 2, weight: 2 },
  { enemy: 'meduse', tier: 2, weight: 2 },
  { enemy: 'banc', tier: 2, weight: 2 },

  // ── Palier 3 : les armes exotiques et les lames.
  { enemy: 'sabreur', tier: 3, weight: 1 },
  { enemy: 'prisme', tier: 3, weight: 1 },
  { enemy: 'kyste', tier: 3, weight: 1 },
  { enemy: 'lame-a', tier: 3, weight: 2 },
  { enemy: 'faucon', tier: 3, weight: 2 },
  { enemy: 'mortier', tier: 3, weight: 2 },

  // ── Palier 4 : les lourds et les blindés — quand le build peut suivre.
  { enemy: 'egide', tier: 4, weight: 1 },
  { enemy: 'phalange', tier: 4, weight: 1 },
  { enemy: 'char', tier: 4, weight: 1 },
  { enemy: 'couveur', tier: 4, weight: 1 },
  { enemy: 'pondeuse', tier: 4, weight: 1 },
  // La NEF — plateforme volante blindée par ses affûts. Un porteur autonome (ses
  // tourelles s'attachent à ELLE), donc éligible au roster ; poids faible, c'est
  // une pièce marquante, pas du fond.
  { enemy: 'nef', tier: 4, weight: 1 },
];
